<template>
  <div class="p-4">
    <button @click="$modal.show('attach-item')" class="float-right border border-blue-500 text-blue-500 font-bold py-2 px-4 rounded mb-6">
      Attach Items
    </button>

    <button v-if="bulkDelete && $route.params.id" @click="handleBulkDelete()" class="float-left border border-red-500 text-red-500 font-bold py-2 px-4 rounded mb-6">
      Detach Items
    </button>
    <el-table
      :data="items"
      :empty-text="'No Level Items available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        v-if="$route.params.id"
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        label="Item">
        <template slot-scope="scope">
          <span>{{scope.row.item.name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Loyalty Level">
        <template slot-scope="scope">
          <span>{{scope.row.loyalty_level ? scope.row.loyalty_level.name : 'N/A'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="percent"
        label="Percentage">
      </el-table-column>
      <el-table-column
        align="center"
        label="Operations">
        <template slot-scope="scope">
          <el-button @click="deleteLevelItem(scope.row.loyalty_level, scope.row.item.id)" type="text" size="small">
            <i title="Delete Level Item" class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-8 mb-8 float-right"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
    <AttachItemsToLevel/>
  </div>
</template>

<script>
import AttachItemsToLevel from './_includes/AttachItemsToLevel.vue';

export default {
  name: 'LevelItems',
  components: {
    AttachItemsToLevel,
  },
  data() {
    return {
      loading: false,
      page: 1,
      limit: 20,
      bulkDelete: false,
      bulkIds: [],
    };
  },
  computed: {
    items() {
      return this.$store.state.LoyaltyModule.items.items;
    },
    pagination() {
      return this.$store.state.LoyaltyModule.items.pagination;
    },
  },
  methods: {
    deleteLevelItem(loyaltyLevel, ids) {
      this.$confirm(`This will permanently remove this item(s) from the ${loyaltyLevel.name} Loyalty Level. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('LoyaltyModule/deleteLevelItem', { loyaltyId: loyaltyLevel.id, itemId: ids });
          this.$notify.success({
            title: 'Success',
            message: 'Loyalty Level Item removed',
          });
        } catch (e) {
          console.log(e)
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    async handleSizeChange(args) {
      this.limit = args;
      await this.fetchLoyaltyItems();
    },
    async handleCurrentChange(args) {
      this.page = args;
      await this.fetchLoyaltyItems();
    },
    async fetchLoyaltyItems() {
      if (!this.$route.params.id) {
        await this.$store.dispatch('LoyaltyModule/fetchAllLoyaltyItems', {
          page: this.page,
          limit: this.limit,
        });
      } else {
        await this.$store.dispatch('LoyaltyModule/fetchItemsByLoyalty', {
          loyaltyId: this.$route.params.id,
          page: this.page,
          limit: this.limit,
        });
      }
    },

    async handleSelectionChange(val) {
      if (val.length > 0) {
        this.bulkDelete = true;
        this.bulkIds = val.map(item => item.item.id).join(',');
      } else {
        this.bulkIds = [];
        this.bulkDelete = false;
      }
    },

    async handleBulkDelete() {
      await this.deleteLevelItem(this.items[0].loyalty_level, this.bulkIds);
    },
  },
  async mounted() {
    try {
      await this.fetchLoyaltyItems();
    } catch (e) {
      // TODO
    }
  },
};
</script>

<style scoped>

</style>
